import { markRaw } from 'vue'

const initialState = () => ({
  catalogs: markRaw([]),
  status: null,
  catalog: null
})

export default initialState
